import { Navigate } from "react-router-dom";
import { usePermissions } from "../../hooks/usePermissions";
import { isAuthenticated } from "../../utils/auth";

const ProtectedRoute = ({
	resourceName,
	permission,
	subpermission = false,
	subresourceName,
	children,
}) => {
	const { hasPermission } = usePermissions();
	if (!isAuthenticated()) {
		return <Navigate to="/login" replace />;
	}

	if (
		resourceName &&
		permission &&
		!hasPermission(resourceName, permission, subresourceName, subpermission)
	) {
		return <Navigate to="/unauthorized" replace />;
	}

	return children;
};

export default ProtectedRoute;
